import { PencilIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { IconButton } from "../../../../../components/ui";
import { buildInvoiceNavigationTargetUrl } from "../../../components/searchResultNavigation";

const Actions = props => {
  const { values } = props || {};
  const { id } = values?.item || values || {};

  if (typeof id == "number") {
    const query = new URLSearchParams(window.location.search);
    const href = buildInvoiceNavigationTargetUrl({
      listContext: { locationSearch: window.location.search },
      recordId: id,
      status: query.get("status") || "all",
    });

    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Link to={href} title="Edit Invoice">
              <IconButton variant="clean" title="Edit Invoice">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
